module.exports = __webpack_public_path__ + "static/media/sub1.2fc31326.png";